import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'gold';
  showArrow?: boolean;
  pulse?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  showArrow = false,
  pulse = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-deep-teal text-white hover:bg-gold hover:text-deep-teal',
    gold: 'bg-gold text-white hover:bg-[#C75B39] hover:text-white'
  };
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-254" />}
    </>;
  if (href) {
    const Comp = pulse ? motion.a : 'a';
    const animationProps = pulse ? {
      animate: {
        scale: [1, 1.02, 1]
      },
      transition: {
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }
    } : {};
    return <Comp href={href} className={`${baseStyles} ${variants[variant]} ${className}`} {...animationProps} data-id="element-255">
        {content}
      </Comp>;
  }
  const Comp = pulse ? motion.button : 'button';
  const animationProps = pulse ? {
    animate: {
      scale: [1, 1.02, 1]
    },
    transition: {
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    }
  } : {};
  return <Comp className={`${baseStyles} ${variants[variant]} ${className}`} {...animationProps} {...props as any} data-id="element-256">
      {content}
    </Comp>;
}